<dx-load-panel
    [hideOnOutsideClick]="false"
    shadingColor="rgba(0,0,0,0.4)"
    [(visible)]="loading">
</dx-load-panel>
<div class="page-wrapper">
  <div class="container">
      <form [formGroup]="reportForm">
        <app-panel [footer]="true" class="mb-3">
          <div class="heading">Generate Warranty Card</div>
          <div class="body">
              <div class="d-flex justify-content-center">
                <div class="dx-field w-300">
                  <div class="text-left">Record No <span >*</span> :</div>
                  <dx-text-box style="width: 100%" formControlName="recordNo">
                    <dx-validator>
                      <dxi-validation-rule type="required" message="Record No is required"></dxi-validation-rule>
                    </dx-validator>
                </dx-text-box>
              </div>
              </div>
               
              
          </div>
          <div class="footer">
            <div class="alert alert-danger mt-3" role="alert" *ngIf="getFormValidationErrors(reportForm)?.length > 0">
              <div><strong>Oops!</strong></div>
              <div class="e" *ngFor="let error of getFormValidationErrors(reportForm)">{{ error.error | uppercase}} {{error.control | uppercase }}</div>
            </div>
            <dx-button id="button" text="Generate" type="default" class="float-right ml-3"
              [disabled]="loading"
              (click)="!reportForm.valid || submitData(reportForm)"
              [useSubmitBehavior]="true">
            </dx-button>
          </div>
        </app-panel>
        <dx-report-viewer [reportUrl]="reportUrl" height="800px" *ngIf="reportUrl">
          <dxrv-request-options [invokeAction]="invokeAction" [host]="hostUrl"></dxrv-request-options>
        </dx-report-viewer>
      </form>
  </div>
</div>
<swal #saveSwal></swal>